"use strict";

exports.__esModule = true;
exports.PlantStateActivityForm = PlantStateActivityForm;
var _react = _interopRequireDefault(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _reactFinalForm = require("react-final-form");
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _Core = require("../../Core");
var _getStatesForActivity = require("../getStatesForActivity");
var _PlantStateActivitiesContext = require("../PlantStateActivitiesContext");
var _Env = require("../../Env");
var _constants = require("../../Auth/constants");
var _UI = require("../../../Utils/UI");
var _excluded = ["value", "selectedDevices", "children", "onSubmit"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/** Finds the current selected activity state mappings and process them in to a list of states to show in the UI form */
function getActivityStatesData(activityId, plantStateActivities) {
  var activityStates = (0, _getStatesForActivity.getStatesForActivity)(activityId, plantStateActivities);
  return plantStateActivities.states.map(function (state) {
    var activityState = activityStates.find(function (s) {
      return s.state.id === state.id;
    });
    return {
      active: Boolean(activityState),
      name: state.name,
      id: state.id,
      rank: activityState ? activityState.rank : 0,
      userAction: activityState ? activityState.userAction : undefined,
      forceComment: activityState && activityState.forceComment || false
    };
  });
}
function PlantStateActivityForm(_ref) {
  var value = _ref.value,
    selectedDevices = _ref.selectedDevices,
    children = _ref.children,
    onSubmit = _ref.onSubmit,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_Env.EnvContext),
    licence = _React$useContext2.licence;
  var isEnrichMode = licence.accessRights.includes(_constants.ACCESS_RIGHT_ENRICH);
  var plantStateActivities = _react["default"].useContext(_PlantStateActivitiesContext.PlantStateActivitiesContext);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return onSubmit(values);
          case 1:
            (0, _UI.showSuccessToaster)(translate("PlantStateActivityForm.success", "Activity saved successfully"));
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            (0, _UI.showErrorToaster)(translate("PlantStateActivityForm.error", "Failed to save activity"));
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var states = getActivityStatesData(value.id, plantStateActivities).filter(function (value) {
    return isEnrichMode || value.id === "downtime.unplanned" || value.id === "downtime.planned";
  });
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, _extends({
    initialValues: Object.assign({}, value, {
      selectedDevices: selectedDevices,
      states: states
    }),
    onSubmit: handleSubmit,
    mutators: _finalFormArrays["default"]
  }, extra), function (_ref3) {
    var form = _ref3.form,
      handleSubmit = _ref3.handleSubmit,
      pristine = _ref3.pristine,
      invalid = _ref3.invalid,
      submitting = _ref3.submitting;
    return /*#__PURE__*/_react["default"].createElement("form", {
      "data-testid": "PlantStateActivityForm",
      onSubmit: handleSubmit,
      style: {
        overflow: "hidden",
        flex: 1
      }
    }, children({
      states: states,
      form: form,
      pristine: pristine,
      invalid: invalid
    }));
  });
}